import React from 'react';
import PropTypes from 'prop-types';
import { Dimmer, Header, Icon } from 'semantic-ui-react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(/* error, info */) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info);
    // Display fallback UI
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Dimmer active page>
          <Header as="h2" icon inverted>
            <Icon name="alarm" />
            Qualcosa è andato storto
            <Header.Subheader>
              <br />
              Ci dispiace, prova a ricaricare la pagina.
              <br />
              Se il problema persiste, ti invitiamo a contattare l’assistenza, per avere maggiori informazioni.
            </Header.Subheader>
          </Header>
        </Dimmer>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
};



// WEBPACK FOOTER //
// ./app/containers/ErrorBoundary/index.js